import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/images/MetubeLogo.png";
import "../assets/js/custom";
import Navigator from "../Component/extra/Navigator";
import { warning } from "../util/Alert";
import $ from "jquery";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { ReactComponent as DownArrow } from "../assets/icons/DownArrow.svg";
import { ReactComponent as Dashboard } from "../assets/sidebarIcon/Dashboard.svg";
import { ReactComponent as User } from "../assets/sidebarIcon/User.svg";
import { ReactComponent as User2 } from "../assets/sidebarIcon/User2.svg";
import { ReactComponent as Channel } from "../assets/sidebarIcon/Channel.svg";
import { ReactComponent as Category } from "../assets/sidebarIcon/Category.svg";
import { ReactComponent as Metrics } from "../assets/sidebarIcon/Metrics.svg";
import { ReactComponent as Contact } from "../assets/sidebarIcon/Contact.svg";
import { ReactComponent as Sound } from "../assets/sidebarIcon/Sound.svg";
import { ReactComponent as Faq } from "../assets/sidebarIcon/Faq.svg";
import { ReactComponent as Report } from "../assets/sidebarIcon/Report.svg";
import { ReactComponent as Profile } from "../assets/sidebarIcon/Profile.svg";
import { ReactComponent as Setting } from "../assets/sidebarIcon/Setting.svg";
import { ReactComponent as Shorts } from "../assets/sidebarIcon/Shorts.svg";
import { ReactComponent as Video } from "../assets/sidebarIcon/Video.svg";
import { ReactComponent as PremiumPlan } from "../assets/sidebarIcon/PremiumPlan.svg";
import { ReactComponent as Currency } from "../assets/sidebarIcon/Currency.svg";
import { ReactComponent as Monetization } from "../assets/sidebarIcon/Monetization.svg";
import { ReactComponent as Withdraw } from "../assets/sidebarIcon/Withdraw.svg";
import { ReactComponent as Earning } from "../assets/sidebarIcon/Earning.svg";
import { ReactComponent as Coupon } from "../assets/sidebarIcon/Coupon.svg";
import { ReactComponent as Logout } from "../assets/sidebarIcon/Logout.svg";
import { useEffect, useState } from "react";
import { LOGOUT_ADMIN } from "../store/admin/admin.type";
import { useDispatch, useSelector } from "react-redux";
import { CLOSE_DIALOGUE } from "../store/dialogue/dialogue.type";
import { projectName } from "../util/config";
import { setToast } from "../util/toast";
import { getOrgProfile } from "../store/organization/organization.action";
import {
  getAdminProfile,
  getOrgMemberProfile,
} from "../store/loggedUser/loggedUser.action";

const Sidebar = () => {
  const { profile, tokenData } = useSelector((state) => state.loggedUser);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (tokenData) {
      if (tokenData.isOrg) {
        dispatch(getOrgProfile());
        dispatch(getOrgMemberProfile());
      } else {
        dispatch(getAdminProfile());
      }
    }
  }, [tokenData]);

  useEffect(() => {
    if (tokenData?.isOrg) {
      if (profile) {
        if (profile.role === "org_viewer") {
          setToast("error", "Viewer don't have access to website");
          dispatch({ type: LOGOUT_ADMIN });
          navigate("/org/login");
        } else if (!profile.isActive) {
          setToast("error", "Your account is disabled by admin");
          dispatch({ type: LOGOUT_ADMIN });
          navigate("/org/login");
        }
      }
    }
  }, [profile, tokenData]);

  const handleLogout = () => {
    handleCloseFunction();
    const data = warning();
    data
      .then((logout) => {
        if (logout) {
          const yes = logout.isConfirmed;
          if (yes) {
            dispatch({ type: LOGOUT_ADMIN });
            if(location.pathname.startsWith("/org")) {
              navigate("/org/login");
            } else {
              navigate("/");
            }
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const handleCloseFunction = () => {
    dispatch({
      type: CLOSE_DIALOGUE,
      payload: {
        dialogue: false,
      },
    });

    let dialogueData_ = {
      dialogue: false,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
    sessionStorage.removeItem("multiButton");
  };

  const orgNavBarArray = [
    {
      name: "Members",
      path: "/org/members",
      navSVG: <User />,
      onClick: handleCloseFunction,
    },
    {
      name: "Departments",
      path: "/org/departments",
      navSVG: <Category />,
      onClick: handleCloseFunction,
    },
    {
      name: "Videos",
      path: "/org/videos",
      navSVG: <Video />,
      onClick: handleCloseFunction,
    },
    {
      name: "Courses",
      path: "/org/courses",
      navSVG: <Report />,
      onClick: handleCloseFunction,
    },
    {
      name: "Profile",
      path: "/org/profile",
      navSVG: <Profile />,
      onClick: handleCloseFunction,
    },
    ...(profile?.role === "org_owner"
      ? [
          {
            name: "Subscription",
            path: "/org/subscription",
            navSVG: <PremiumPlan />,
            onClick: handleCloseFunction,
          },
          {
            name: "Payments",
            path: "/org/payments",
            navSVG: <ReceiptLongOutlinedIcon />,
            onClick: handleCloseFunction,
          },
        ]
      : []),
    {
      name: "Log Out",
      navSVG: <Logout />,
      onClick: handleLogout,
    },
  ];

  const orgCreatorNavBar = [
    {
      name: "Videos",
      path: "/org/videos",
      navSVG: <Video />,
      onClick: handleCloseFunction,
    },
    {
      name: "Courses",
      path: "/org/courses",
      navSVG: <Report />,
      onClick: handleCloseFunction,
    },
    {
      name: "Profile",
      path: "/org/profile",
      navSVG: <Profile />,
      onClick: handleCloseFunction,
    },
    {
      name: "Log Out",
      navSVG: <Logout />,
      onClick: handleLogout,
    },
  ];

  const navBarArray = [
    {
      name: "Dashboard",
      path: "/admin/mainDashboard",
      navSVG: <Dashboard />,
      onClick: handleCloseFunction,
    },
    {
      name: "Sub Admin",
      path: "/admin/roleManagement",
      navSVG: <User2 />,
      onClick: handleCloseFunction,
    },
    {
      name: "User",
      path: "/admin/userTable",
      navSVG: <User />,
      onClick: handleCloseFunction,
    },
    {
      name: "Organization",
      path: "/admin/organizations",
      navSVG: <User />,
      onClick: handleCloseFunction,
    },
    {
      name: "Channel",
      path: "/admin/channel",
      navSVG: <Channel />,
      onClick: handleCloseFunction,
    },
    {
      name: "Category",
      path: "/admin/videoCategories",
      navSVG: <Category />,
      onClick: handleCloseFunction,
    },
    {
      name: "Videos",
      path: "/admin/videos",
      navSVG: <Video />,
      onClick: handleCloseFunction,
    },

    {
      name: "Shorts",
      path: "/admin/shorts",
      navSVG: <Shorts />,
      onClick: handleCloseFunction,
    },
    {
      name: "Courses",
      path: "/admin/courses",
      navSVG: <Report />,
      onClick: handleCloseFunction,
    },
    {
      name: "Metrics",
      path: "/admin/metrics",
      navSVG: <Metrics />,
      onClick: handleCloseFunction,
    },
    {
      name: "Report",
      path: "/admin/allreport",
      navSVG: <Report />,
      onClick: handleCloseFunction,
    },
    {
      name: "Sound",
      path: "/admin/sound",
      navSVG: <Sound />,
      onClick: handleCloseFunction,
    },
    {
      name: "Subscription Plans",
      path: "/admin/subscription-plan",
      navSVG: <PremiumPlan />,
      onClick: handleCloseFunction,
    },
    {
      name: "Coupon",
      path: "/admin/coupon",
      navSVG: <Coupon />,
      onClick: handleCloseFunction,
    },
    {
      name: "Premium Plan",
      path: "/admin/premiumPlanTable",
      navSVG: <PremiumPlan />,
      onClick: handleCloseFunction,
    },
    {
      name: "Currency",
      path: "/admin/allCurrency",
      navSVG: <Currency />,
      onClick: handleCloseFunction,
    },

    {
      name: "Monetization Request",
      path: "/admin/allmonetizationRequest",
      navSVG: <Monetization />,
      onClick: handleCloseFunction,
    },
    {
      name: "Withdraw Request",
      path: "/admin/withrawRequest",
      navSVG: <Withdraw />,
      onClick: handleCloseFunction,
    },
    {
      name: "Admin Earning",
      path: "/admin/adminEarnings",
      navSVG: <Earning />,
      onClick: handleCloseFunction,
    },
    {
      name: "Payments",
      path: "/admin/payments",
      navSVG: <ReceiptLongOutlinedIcon />,
      onClick: handleCloseFunction,
    },
  ];

  const generalArray = [
    {
      name: "FAQ",
      path: "/admin/allfaq",
      navSVG: <Faq />,
      onClick: handleCloseFunction,
    },
    {
      name: "Contact Us",
      path: "/admin/contactUs",
      navSVG: <Contact />,
      onClick: handleCloseFunction,
    },
    {
      name: "Profile",
      path: "/admin/profile",
      navSVG: <Profile />,
      onClick: handleCloseFunction,
    },

    {
      name: "Setting",
      path: "/admin/settingPage",
      navSVG: <Setting />,
      onClick: handleCloseFunction,
    },

    {
      name: "Log Out",
      navSVG: <Logout />,
      onClick: handleLogout,
    },
  ];

  const [totalPage, setTotalPage] = useState(20);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    if (mediaQuery?.matches) {
      $(".sideBar.mobSidebar").removeClass("mobSidebar");
      $(".sideBar").addClass("webSidebar");
    }
    $(".mobSidebar-bg").removeClass("responsive-bg");
  }, [location.pathname]);

  return (
    <>
      <Script totalPage={totalPage} />
      <div className="mainSidebar">
        <div className="sideBar webSidebar">
          <div className="sideBarLogo boxCenter">
            <Link
              to={tokenData?.isOrg ? "/org/dashboard" : "/admin/mainDashboard"}
              className="d-flex align-items-center cursor-pointer"
            >
              <img src={Logo} alt="" width={"40px"} />
              <span className="fs-3 fw-bold text-black">{projectName}</span>
            </Link>
          </div>
          {tokenData?.isOrg == true ? (
            <div className="navigation">
              <p
                style={{
                  fontSize: "16px",
                  paddingLeft: "20px",
                  fontWeight: "700",
                }}
              >
                Menu
              </p>
              {/* <nav style={{ backgroundColor: "#f0f0f0" }}> */}
              <nav
                style={{
                  background: "white",
                  borderRadius: "10px",
                  color: "#404040",
                }}
              >
                <Navigator
                  name={"Dashboard"}
                  path={"/org/dashboard"}
                  navSVG={<Dashboard />}
                  onClick={handleCloseFunction}
                />
                {(profile?.role === "org_admin" || profile?.role === "org_owner"
                  ? orgNavBarArray
                  : orgCreatorNavBar
                ).map((res) => {
                  return (
                    <>
                      <Navigator
                        name={res?.name}
                        path={res?.path}
                        navIcon={res?.navIcon}
                        navIconImg={res?.navIconImg}
                        navSVG={res?.navSVG}
                        onClick={res?.onClick && res?.onClick}
                      >
                        {res?.subMenu &&
                          res?.subMenu?.map((subMenu) => {
                            return (
                              <Navigator
                                subName={subMenu.subName}
                                subPath={subMenu.subPath}
                                subPath2={subMenu.subPath2}
                                onClick={subMenu.onClick}
                              />
                            );
                          })}
                      </Navigator>
                    </>
                  );
                })}
              </nav>
            </div>
          ) : tokenData?.isSubAdmin === false ? (
            <div className="navigation">
              <p
                style={{
                  fontSize: "16px",
                  paddingLeft: "20px",
                  fontWeight: "700",
                }}
              >
                Menu
              </p>
              {/* <nav style={{ backgroundColor: "#f0f0f0" }}> */}
              <nav
                style={{
                  background: "white",
                  borderRadius: "10px",
                  color: "#404040",
                }}
              >
                {/* About */}
                {navBarArray?.length > 0 && (
                  <>
                    {(totalPage > 0
                      ? navBarArray.slice(0, totalPage)
                      : navBarArray
                    ).map((res) => {
                      return (
                        <>
                          <Navigator
                            name={res?.name}
                            path={res?.path}
                            path2={res?.path2}
                            navIcon={res?.navIcon}
                            navIconImg={res?.navIconImg}
                            navSVG={res?.navSVG}
                            onClick={res?.onClick && res?.onClick}
                          >
                            {res?.subMenu &&
                              res?.subMenu?.map((subMenu) => {
                                return (
                                  <Navigator
                                    subName={subMenu.subName}
                                    subPath={subMenu.subPath}
                                    subPath2={subMenu.subPath2}
                                    onClick={subMenu.onClick}
                                  />
                                );
                              })}
                          </Navigator>
                        </>
                      );
                    })}
                  </>
                )}
              </nav>

              <p
                style={{
                  marginTop: "10px",
                  fontSize: "16px",
                  paddingLeft: "20px",
                  fontWeight: "700",
                }}
              >
                General
              </p>
              <nav
                style={{
                  background: "white",
                  borderRadius: "10px",
                  color: "#404040",
                }}
              >
                {/* About */}
                {generalArray?.length > 0 && (
                  <>
                    {(totalPage > 0
                      ? generalArray.slice(0, totalPage)
                      : generalArray
                    ).map((res) => {
                      return (
                        <>
                          <Navigator
                            name={res?.name}
                            path={res?.path}
                            path2={res?.path2}
                            navIcon={res?.navIcon}
                            navIconImg={res?.navIconImg}
                            navSVG={res?.navSVG}
                            onClick={res?.onClick && res?.onClick}
                          >
                            {res?.subMenu &&
                              res?.subMenu?.map((subMenu) => {
                                return (
                                  <Navigator
                                    subName={subMenu.subName}
                                    subPath={subMenu.subPath}
                                    subPath2={subMenu.subPath2}
                                    onClick={subMenu.onClick}
                                  />
                                );
                              })}
                          </Navigator>
                        </>
                      );
                    })}
                  </>
                )}
              </nav>
              <div className="boxCenter mt-2">
                <DownArrow
                  onClick={() => setTotalPage(navBarArray.length)}
                  className={`text-center mx-auto cursor ${
                    totalPage === navBarArray.length && "d-none"
                  }`}
                  style={{ transition: "0.5s" }}
                />
              </div>
            </div>
          ) : (
            <div className="navigation">
              <p
                style={{
                  fontSize: "16px",
                  paddingLeft: "20px",
                  fontWeight: "700",
                }}
              >
                Menu
              </p>
              {/* <nav style={{ backgroundColor: "#f0f0f0" }}> */}
              <nav
                style={{
                  background: "white",
                  borderRadius: "10px",
                  color: "#404040",
                }}
              >
                {/* About */}
                {profile?.roles?.length > 0 && (
                  <>
                    <Navigator
                      name={"Dashboard"}
                      path={"/admin/subdashboard"}
                      navSVG={<Dashboard />}
                      onClick={handleCloseFunction}
                    ></Navigator>
                    {(totalPage > 0
                      ? profile?.roles.slice(0, totalPage)
                      : profile?.roles
                    ).map((res) => {
                      return (
                        <>
                          <Navigator
                            name={res?.name}
                            path={res?.path}
                            navSVG={
                              res?.name === "User" ? (
                                <User />
                              ) : res?.name === "Organization" ? (
                                <User />
                              ) : res?.name === "Channel" ? (
                                <Channel />
                              ) : res?.name === "Category" ? (
                                <Category />
                              ) : res?.name === "Videos" ? (
                                <Video />
                              ) : res?.name === "Shorts" ? (
                                <Shorts />
                              ) : res?.name === "Report" ? (
                                <Report />
                              ) : res?.name === "Sound" ? (
                                <Sound />
                              ) : res?.name === "Premium Plan" ? (
                                <PremiumPlan />
                              ) : res?.name === "FAQ" ? (
                                <Faq />
                              ) : res?.name === "Contact Us" ? (
                                <Contact />
                              ) : res?.name === "Setting" ? (
                                <Setting />
                              ) : res?.name === "Courses" ? (
                                <Report />
                              ) : res?.name === "Subscription Plan" ? (
                                <PremiumPlan />
                              ) : res?.name === "Coupons" ? (
                                <Coupon />
                              ) : res?.name === "Payments" ? (
                                <ReceiptLongOutlinedIcon />
                              ) : (
                                <Dashboard />
                              )
                            }
                            onClick={handleCloseFunction}
                          ></Navigator>
                        </>
                      );
                    })}
                    <Navigator
                      name={"Log Out"}
                      navSVG={<Logout />}
                      onClick={handleLogout}
                    ></Navigator>
                  </>
                )}
              </nav>

              <div className="boxCenter mt-2">
                <DownArrow
                  onClick={() => setTotalPage(navBarArray.length)}
                  className={`text-center mx-auto cursor ${
                    totalPage === navBarArray.length && "d-none"
                  }`}
                  style={{ transition: "0.5s" }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;

export const Script = (props) => {
  useEffect(() => {
    const handleClick = (event) => {
      const target = $(event.currentTarget);
      const submenu = target.next(".subMenu");

      $(".subMenu").not(submenu).slideUp();
      submenu.slideToggle();

      // Toggle rotation class on the clicked icon
      target.children("i").toggleClass("rotate90");

      // Remove rotation class from other icons
      $(".mainMenu > li > a > i")
        .not(target.children("i"))
        .removeClass("rotate90");
    };

    const handleToggle = () => {
      $(".mainNavbar").toggleClass("mobNav webNav");
      $(".sideBar").toggleClass("mobSidebar webSidebar");

      $(".mainAdmin").toggleClass("mobAdmin");
      $(".fa-angle-right").toggleClass("rotated toggleIcon");

      var checkClass = $(".sideBar").hasClass("mobSidebar");
      if (checkClass) {
        var mobSidebarBg = document.querySelector(".mobSidebar-bg");
        mobSidebarBg.classList.add("responsive-bg");
      } else {
        $(".mobSidebar-bg").removeClass("responsive-bg");
      }
    };

    $(".subMenu").hide();
    $(".mainMenu > li > a").on("click", handleClick);
    $(".navToggle").on("click", handleToggle);

    return () => {
      $(".mainMenu > li > a").off("click", handleClick);
      $(".navToggle").off("click", handleToggle);
    };
  }, [props.totalPage]);

  return null;
};
